<template>
  <div>
    <andes-header></andes-header>
    <div class="container payment-page">
      <div class="row justify-content-center">
        <div class="col-sm-8 col-md-6">
          <div class="card shadow mt-4">
            <div class="card-body text-center">
              <p class="text-muted mb-2">{{ $t('Modo de pago simulado') }}</p>
              <h3 class="m-0 mb-3">{{ changeId ? 'PAGO DE CAMBIO DE VUELO' : 'PAGO DE RESERVA' }}</h3>
              <div class="reservation mb-3" v-if="recordLocator">{{ $t('Reserva:') }} {{ recordLocator }}</div>
              <h3 class="total-title">{{ $t('TOTAL A PAGAR:') }} <span>ARS {{ toCurrencyFormat(amount) }}</span></h3>
              <hr/>
              <p class="mb-4">{{ $t('Confirmá el pago para agregar el medio configurado a la reserva.') }}</p>
              <button type="button" class="btn btn-andes btn-lg" :disabled="loading || !canPay" @click="onPay">
                {{ $t('Pagar') }}
              </button>
              <p class="text-danger mt-3 mb-0" v-if="error">{{ $t(error) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-if="loading"></loading-modal>
  </div>
</template>

<script>
  import AndesHeader from "../components/AndesHeader";
  import LoadingModal from "../components/LoadingModal";
  import { formatMoney } from "../utils/utils";
  import { confirmDummyChangePayment, confirmDummyPayment, getBooking } from '@/api/api';
  import { mapState } from 'vuex';

  export default {
    name: 'dummy-payment-page',
    components: {
      AndesHeader,
      LoadingModal
    },
    computed: {
      ...mapState(['afterPaymentRoute']),
      canPay: function () {
        return !!this.bookingId && !!this.recordLocator;
      }
    },
    data: function () {
      return {
        loading: false,
        error: null,
        bookingId: null,
        recordLocator: null,
        lastName: null,
        amount: 0,
        changeId: null
      }
    },
    methods: {
      toCurrencyFormat: function (amount) {
        return formatMoney(amount);
      },
      readParams: function () {
        const query = this.$route.query || {};
        this.bookingId = query.bookingId ? parseInt(query.bookingId, 10) : null;
        this.recordLocator = query.rl || null;
        this.lastName = query.ln || null;
        this.amount = query.amount ? parseFloat(query.amount) : 0;
        this.changeId = query.changeId ? parseInt(query.changeId, 10) : null;
      },
      goAfterPayment: function () {
        let next = this.afterPaymentRoute || 'itinerary';
        this.$store.commit('afterPaymentRoute', null);
        this.$store.commit('loading', false);
        if (this.recordLocator && this.lastName) {
          this.$store.commit('loading', true);
          getBooking({ rl: this.recordLocator, ln: this.lastName }, (result) => {
            this.$store.commit('loading', false);
            if (result && result.BookingID) {
              this.$store.dispatch('updateBooking', result);
            }
            this.$router.replace(next);
          });
          return;
        }
        this.$router.replace(next);
      },
      onPaid: function (response) {
        this.loading = false;
        this.$store.commit('loading', false);
        if (response && response.result === 'ok') {
          this.goAfterPayment();
          return;
        }
        if (response && response.URL && !this.afterPaymentRoute) {
          window.location.href = response.URL;
          return;
        }
        this.error = (response && response.message) || this.$t('Error al simular el pago. Intente nuevamente.');
      },
      onPay: function () {
        if (!this.canPay || this.loading) {
          return;
        }
        this.loading = true;
        this.error = null;
        this.$store.commit('loading', true);
        if (this.changeId) {
          confirmDummyChangePayment({
            RecordLocator: this.recordLocator,
            BookingID: this.bookingId,
            ChangeID: this.changeId,
          }, this.onPaid, (err) => {
            this.loading = false;
            this.$store.commit('loading', false);
            this.error = typeof err === 'string' ? err : this.$t('Error al simular el pago del cambio.');
          });
          return;
        }
        confirmDummyPayment(this.recordLocator, this.bookingId, this.onPaid);
      }
    },
    mounted() {
      this.readParams();
      this.$store.commit('loading', false);
      if (!this.canPay) {
        this.error = this.$t('Faltan datos del pago simulado.');
      }
    }
  }
</script>
